<template>
  <div>
    <Index
      v-if="show === 'index'"
      :vehicles="vehicles"
      :meta="meta"
      :query="query"
      :order="order"
      :changeQuery="changeQuery"
      :numberOfBadges="numberOfBadges"
      :updateNumberOfBadges="updateNumberOfBadges"
      :buildParams="buildParams"
      :infoTotalModels="infoTotalModels"
      @find="find()"
      @sendDeleteVehicle="sendDeleteVehicle"
      @pagination="pagination($event)"
      @createVehicle="createVehicle"
      @showVehicle="showVehicle($event)"
    />

    <Show
      v-else @deletedVehicle="show = 'index'"
      @toIndex="show = 'index'"
      @sendDeleteVehicle="sendDeleteVehicle"
      @editVehicle="updateVehicle"
      :vehicle="vehicle"
    />

    <ModalDeleteVehicle
      v-model="showModalDeleteVehicle"
      title="Excluir veículo"
      :vehicle="vehicle"
      @sendDeleteModel="deleteVehicle"
    />

    <Modal v-model="showModalFormVehicle" width="sm">
      <span slot="header">{{ titleVehicleForm }}</span>
      <FormVehicle
        v-if="showModalFormVehicle"
        :vehicle="vehicle"
        @cancel="showModalFormVehicle = false"
        @saved="savedVehicle($event)"
      />
    </Modal>
  </div>
</template>

<script>
  import Index from '@/components/vehicles/container/Index'
  import FormVehicle from '@/components/vehicles/FormVehicle'
  import Show from '@/components/vehicles/container/Show'
  import Modal from '../shares/specialTag/Modal'
  import ModalDeleteVehicle from '@/components/vehicles/ModalDeleteVehicle'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'
  import { VEHICLE_STATUS } from '@/utils/vehicleStatus'

  export default {
    components: { FormVehicle, Index, Modal, ModalDeleteVehicle, Show },
    computed: {
      vehicles() {
        return this.getModels || []
      }
    },
    created() {
      this.$set(this.query, 'entityStatusId', VEHICLE_STATUS.ENABLED)
      this.$set(this.query, 'crlvStatus', '')
      this.asyncTemplateSelect()
    },
    data() {
      return {
        nameModel: 'Vehicle',
        show: 'index',
        showModalDeleteVehicle: false,
        showModalFormVehicle: false,
        titleVehicleForm: '',
        vehicle: null,
      }
    },
    methods: {
      createVehicle() {
        this.vehicle = null
        this.titleVehicleForm = 'Cadastrar veículo'
        this.showModalFormVehicle = true
      },
      deleteVehicle(vehicle) {
        this.asyncTemplateDelete(vehicle, {
          after: () => {
            this.showModalDeleteVehicle = false
            this.show = 'index'
            this.find()
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      },
      loadCrlvSummary(models) {
        if (!models || !models.length)
          return

        this.axios.get('vehicle_documents/summary', { params: { vehicle_ids: models.map(m => m.id) } })
          .then(response => {
            const map = (response && response.data) || {}
            models.forEach(model => this.$set(model, 'crlvSummary', map[model.id] || map[String(model.id)] || null))
          })
          .catch(() => {})
      },
      savedVehicle(vehicle) {
        this.find()
        this.showVehicle(vehicle)
      },
      sendDeleteVehicle(vehicle) {
        this.vehicle = vehicle
        this.showModalDeleteVehicle = true
      },
      showVehicle(vehicle) {
        this.showModalFormVehicle = false
        this.vehicle = vehicle
        this.show = 'show'
      },
      updateVehicle(vehicle) {
        this.titleVehicleForm = 'Editar veículo'
        this.vehicle = vehicle
        this.showModalFormVehicle = true
      },
    },
    mixins: [GetAccount, ModelMapper],
    name: 'Container',
    watch: {
      vehicles(models) {
        this.loadCrlvSummary(models)
      }
    }
  }
</script>

<style scoped>

</style>
